/*
 * @Description: 带tag的多选select
 * @Author: hanpengtao
 * @Date: 2022-04-26 15:37:57
 */
import React, { useState, useEffect, useMemo } from 'react';
import { Select, message, Empty } from 'antd';
import VirtualSelect from 'antd-virtual-select';
import './index.less';

const { Option } = Select;

const SelectWithTags = (props) => {
  const { label, value, sourceList, onChange, style, isVirtual,hasChange, ...restProps } = props;

  const [selectedTags, setSelectedTags] = useState([]);

  const listMap = useMemo(() => new Map(), []);
  
  const [selectValue,setSelectValue] =useState('');


  const CustomSelect = useMemo(() => 
    isVirtual ? VirtualSelect : Select
  ,[isVirtual]);
  
  useEffect(()=>{
    setSelectedTags([])
    setSelectValue('');
  },[hasChange])

  useEffect(() => {
    listMap.clear();
    sourceList?.length && sourceList.forEach(item => {
      listMap.set(item.id, item.name);
    });
    setSelectValue(null);
  }, [sourceList]);

  useEffect(() => {
    setSelectValue(null)
    const tags = value?.map(id =>
      ({
        id,
        name: listMap.get(id),
      })) 
    setSelectedTags(
      tags
    )
  }, [JSON.stringify(value)]);



  const addChoose = (selectValue) => {
    if (selectValue) {
      const isRepeat = selectedTags.some(item => item.id === selectValue);
      if (isRepeat) {
        message.error(`您已添加某个${label}`);
      } else {
        const newSelectTags = [
          ...selectedTags,
          {
            id:selectValue,
            name: listMap.get(selectValue) 
          }
        ];
        setSelectedTags(newSelectTags);
        setSelectValue(null)
        onChange(newSelectTags.map(item => item.id))
      }
    } else {
      message.error(`请选择${label}`);
    }
  }
  //这里的修改是为了能取消添加这个冗余按钮，为什么不传value是觉得多选操作比较怪，为了不影响源逻辑就传了一个单元素数组，如果有问题可以改回来
  const handleChange = (value) => {
    addChoose(value)
  }

  const handleDelete = (id) => {
    const newSelectTags = selectedTags.filter(item => item.id !== id);
    setSelectedTags(newSelectTags);
    onChange(newSelectTags.map(item => item.id));
  }
  return (
    <div className='selectWithTags'>
      <span>{label}：</span>
      <CustomSelect
        style={style}
        showSearch
        showArrow
        allowClear
        placeholder='请选择'
        optionFilterProp="children"
        autoClearSearchValue={true}
        notFoundContent={
          <Empty className='ant-empty-small' image={Empty.PRESENTED_IMAGE_SIMPLE} />
        }
        value={selectValue}
        onChange={handleChange}
        {...restProps}
      >
        {
          sourceList?.map((item) => (
            <Option value={item.id} key={item.id}>
              {item.name}
            </Option>
          ))
        }
      </CustomSelect>

      <div className='tagsInput'>
        <ul className='tagList'>
          {selectedTags?.map((item, index) => (
            <li className='tagListItem' key={index}>
              <span>{item.name}</span>
              <span onClick={() => handleDelete(item.id)}>X</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default SelectWithTags;